import React, { memo, useMemo, useRef } from 'react';
import Lottie from 'lottie-react';

import djAnimation from '@/playlist/games/letterParty/assets/lottie/dj-level-1.json';

interface DjLevelProps {
	className?: string;
	score?: number;
}

const TEXT_LAYER_TYPE = 5;
const SCORE_LAYER_NAME = '24';

const DjLevel = ({ className, score = 0 }: DjLevelProps) => {
	// Cache the base cloned animation to avoid re-cloning on every score change
	const baseAnimationRef = useRef<any>(null);

	const animationData = useMemo(() => {
		// Clone the base animation only once
		if (!baseAnimationRef.current) {
			baseAnimationRef.current = structuredClone(djAnimation);
		}

		// Create a shallow copy with only the layers array cloned
		const clonedData = {
			...baseAnimationRef.current,
			layers: baseAnimationRef.current.layers.map((layer: any) => {
				// Only deep clone the text layer that needs updating
				if (layer.ty === TEXT_LAYER_TYPE && layer.nm === SCORE_LAYER_NAME) {
					const clonedLayer = structuredClone(layer);
					if (clonedLayer.t?.d?.k?.[0]?.s) {
						clonedLayer.t.d.k[0].s.t = String(score);
					}
					return clonedLayer;
				}
				// Return the original layer reference for unchanged layers
				return layer;
			}),
		};

		return clonedData;
	}, [score]);

	return <Lottie animationData={animationData} loop className={className} />;
};

export default memo(DjLevel);
